export default {
    'FORBIDDEN.NOT.MANAGER': 'Cet utilisateur n’a pas de profile Manager, il ne peut pas utiliser Calizy SaaS, merci de contacter l’administrateur du compte' +
        ' pour obtenir le profile de Manager',
};
